import styled, { css } from 'styled-components';
import {
  WorkOutlineOutlined as WorkOutlineOutlinedIcon,
  AddShoppingCart as AddShoppingCartIcon,
  LocalGroceryStore as LocalGroceryStoreIcon,
} from '@mui/icons-material';
import { Link, Typography } from '../../design-system';
import { i18n } from '../../i18n';
import { useLocation } from 'react-router-dom';

export const DashboardBottomNavigationBase = styled.div<{ visible?: boolean }>`
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  background-color: var(--white);
  height: 6rem;
  border-top: 0.1rem solid var(--gray-50);
  margin-bottom: -6rem;

  transition: margin-bottom 0.3s;

  ${(props) =>
    props.visible &&
    css`
      margin-bottom: 0;
    `}
`;

const NavigationButtonBase = styled.button<{ isActive?: boolean }>`
  display: grid;
  grid-template-rows: max-content max-content;
  align-content: center;
  justify-items: center;
  width: 100%;
  height: 100%;

  background-color: var(--gray-30);
  color: var(--gray-90);
  cursor: pointer;
  border: none;
  transition: background-color 0.3s, color 0.3s, opacity 0.3s;

  & > p {
    color: var(--gray-90);
  }
  & > svg {
    width: 2.4rem;
    height: 2.4rem;
  }

  ${(props) =>
    !props.isActive &&
    css`
      &:hover {
        background-color: var(--gray-50);
        color: var(--gray-70);
      }
    `}

  ${(props) =>
    props.isActive &&
    css`
      background-color: var(--gray-90);
      color: var(--white);

      & > p {
        color: var(--white);
      }

      &:hover {
        opacity: 0.7;
      }
    `}
`;

interface NavigationButtonProps {
  to: string;
  isActive: boolean;
  children: React.ReactNode;
}

const NavigationButton = ({ to, isActive, children }: NavigationButtonProps) => {
  return (
    <Link to={to}>
      <NavigationButtonBase isActive={isActive}>{children}</NavigationButtonBase>
    </Link>
  );
};

export const DashboardBottomNavigation = ({ visible }: { visible?: boolean }) => {
  const { pathname } = useLocation();

  return (
    <DashboardBottomNavigationBase visible={visible}>
      <NavigationButton
        to="/dashboard/containers"
        isActive={pathname.includes('/dashboard/containers')}
      >
        <WorkOutlineOutlinedIcon />
        <Typography variant="textXS">{i18n.t('button.containers')}</Typography>
      </NavigationButton>
      <NavigationButton
        to="/dashboard/marketplace"
        isActive={pathname.includes('/dashboard/marketplace')}
      >
        <AddShoppingCartIcon />
        <Typography variant="textXS">{i18n.t('button.marketplace')}</Typography>
      </NavigationButton>
      {/* <NavigationButton to="/dashboard/managesales" isActive={pathname.includes('/dashboard/managesales')}>
        <StorefrontIcon />
        <Typography variant="textXS">{i18n.t('button.manageSales')}</Typography>
      </NavigationButton> */}
      <NavigationButton to="/dashboard/cart" isActive={pathname.includes('/dashboard/cart')}>
        <LocalGroceryStoreIcon />
        <Typography variant="textXS">{i18n.t('button.cart')}</Typography>
      </NavigationButton>
    </DashboardBottomNavigationBase>
  );
};
